"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapBaseTokenStep = void 0;
const step_1 = require("../step");
const relay_adapt_contract_1 = require("../../contract/adapt/relay-adapt-contract");
const wrap_util_1 = require("../../utils/wrap-util");
const token_1 = require("../../utils/token");
class WrapBaseTokenStep extends step_1.Step {
    config = {
        name: 'Wrap Base Token',
        description: 'Wraps base token into wrapped token, ie ETH to WETH.',
    };
    amount;
    constructor(amount) {
        super();
        this.amount = amount;
    }
    async getStepOutput(input) {
        const { networkName, erc20Amounts } = input;
        const baseToken = (0, wrap_util_1.getBaseToken)(networkName);
        const { erc20AmountForStep, unusedERC20Amounts } = this.getValidInputERC20Amount(erc20Amounts, erc20Amount => (0, token_1.compareERC20Info)(erc20Amount, baseToken), this.amount);
        const contract = new relay_adapt_contract_1.RelayAdaptContract(input.networkName);
        const crossContractCalls = [
            await contract.createBaseTokenWrap(this.amount),
        ];
        const wrappedBaseERC20Amount = {
            ...erc20AmountForStep,
            isBaseToken: false,
            expectedBalance: this.amount ?? erc20AmountForStep.expectedBalance,
            minBalance: this.amount ?? erc20AmountForStep.minBalance,
        };
        const spentBaseERC20Amount = {
            ...baseToken,
            amount: this.amount ?? erc20AmountForStep.expectedBalance,
            recipient: 'Wrapped Token Contract',
        };
        return {
            crossContractCalls,
            spentERC20Amounts: [spentBaseERC20Amount],
            outputERC20Amounts: [wrappedBaseERC20Amount, ...unusedERC20Amounts],
            outputNFTs: input.nfts,
        };
    }
}
exports.WrapBaseTokenStep = WrapBaseTokenStep;
